import MarkdownRenderer from "../components/MarkdownRenderer";

const TodoReact = () => {
  return (
    <div>
      <MarkdownRenderer filePath="/posts/TodoReact.md" />
    </div>
  );
};

export default TodoReact;
